import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".NewsletterConfirmModal-module_newsletterModalText__p6jWc {\n  padding: var(--pp-spacing-l) var(--pp-spacing-m) var(--spacingSmall) var(--pp-spacing-m);\n  background-color: var(--pp-color-neutral-ultralight);\n}";
var styles = {"newsletterModalText":"NewsletterConfirmModal-module_newsletterModalText__p6jWc"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=NewsletterConfirmModal.module.scss.js.map
